import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_EQUIPOS = 'ALL_EQUIPOS';
export const ACTIVO_EQUIPOS = 'ACTIVO_EQUIPOS';
export const LOADING_ALL_EQUIPOS = 'LOADING_ALL_EQUIPOS';
export const PARAMS_EQUIPOS = 'PARAMS_EQUIPOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const equiposReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_EQUIPOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_EQUIPOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_EQUIPOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_EQUIPOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
